import { render, staticRenderFns } from "./MdinEditAppr.vue?vue&type=template&id=390d6ca4&scoped=true&"
import script from "./MdinEditAppr.vue?vue&type=script&lang=js&"
export * from "./MdinEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390d6ca4",
  null
  
)

export default component.exports